/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2023, 2025
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { createAsyncThunk } from '@reduxjs/toolkit';

import type { CreateAsyncThunk } from '@ibm-watson/shared/ts/state';
import * as segmentApi from '../../api/segment';

interface ValidateSegmentKeyPayload {
  valid: boolean;
  key: string;
}
export const validateSegmentKey = createAsyncThunk<
  ValidateSegmentKeyPayload,
  string,
  CreateAsyncThunk
>('integrations/validateSegmentKey', async (segmentKey: string) => {
  try {
    const valid = await segmentApi.validateKey(segmentKey);
    return {
      valid,
      key: valid ? segmentKey : 'Invalid key'
    };
  } catch (error) {
    throw error;
  }
});
